import React from "react";
import { motion } from "framer-motion";

const PEPPERONI = "radial-gradient(circle at 25% 30%, #B91C1C 0 3px, transparent 4px), radial-gradient(circle at 70% 65%, #B91C1C 0 3px, transparent 4px), radial-gradient(circle at 60% 20%, #0C4A28 0 2px, transparent 3px)";

export default function TrayMeter({ filled = 0, slots = 4, size = "md", testid = "tray-meter" }) {
  const h = size === "lg" ? "h-14" : size === "sm" ? "h-6" : "h-9";
  return (
    <div className={`flex gap-1 p-1 rounded-xl bg-biga-ink/85 border-2 border-biga-ink ${h}`} data-testid={testid} data-filled={filled} role="img" aria-label={`${filled} of ${slots} tray slots filled`}>
      {Array.from({ length: slots }).map((_, i) => (
        <motion.div key={`slot-${i}`} initial={false} animate={{ scale: i < filled ? 1 : 0.92, opacity: i < filled ? 1 : 0.35 }} transition={{ type: "spring", stiffness: 380, damping: 22, delay: i * 0.04 }}
          className={`flex-1 rounded-md ${i < filled ? "bg-[#F4B860]" : "bg-biga-cream/20 border border-dashed border-biga-cream/40"}`}
          style={i < filled ? { backgroundImage: PEPPERONI, boxShadow: "inset 0 0 0 2px #FF5003" } : undefined} />
      ))}
    </div>
  );
}
